import { useCancelSubscriptionMutationApi } from '@aibees/shared/api';
import {
  CancelSubscriptionReason,
  SubscriptionActiveAction,
} from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http';
import { useState } from 'react';
import { useCurrentSubscriptionApi } from '../../price-and-plan/api/use-current-subscription-api';
import { SubscriptionFlow } from '../types';
import { useSubscriptionModals } from './use-subscription-modals';

export function useCancelSchedulePlanFlow(): SubscriptionFlow {
  const { activeModal, closeModal, openModal } = useSubscriptionModals();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { data } = useCurrentSubscriptionApi();

  const api = useCancelSubscriptionMutationApi(
    data && data?.next?.id,
    SubscriptionActiveAction.SCHEDULE
  );

  // ---------------------------------- Handlers --------------------------------
  const handleStart = async () => {
    setIsLoading(true);
    await api.mutateAsync({
      feedback: CancelSubscriptionReason.OTHER,
      comment: '',
    });
    await baseQueryClient.invalidateQueries([useCurrentSubscriptionApi.name]);
    window.location.hash = '#successCancelDowngrade';
  };

  return {
    activeModal,
    onStart: handleStart,
    closeModal,
  };
}
